import { Activity } from "lucide-react";

const TXT = {
  it: { title: "Picchi di memoria più alti nel periodo", note: "Valore massimo di ogni ora, misurato ogni 30 secondi: include anche i picchi brevi che i campioni ogni 15 minuti non vedono.", when: "Data e ora", pct: "Memoria", used: "Occupata", empty: "Nessun picco registrato nel periodo: la misura ogni 30 secondi è attiva dal 2 novembre 2026." },
  en: { title: "Highest memory peaks in the period", note: "Maximum of each hour, measured every 30 seconds: includes short peaks that 15-minute samples miss.", when: "Date and time", pct: "Memory", used: "Used", empty: "No peaks recorded in the period: 30-second measurement is active since 2 November 2026." },
};

export const InfraPeaksTable = ({ peaks, lang = "it", red }) => {
  const t = TXT[lang === "en" ? "en" : "it"];
  const loc = lang === "en" ? "en-GB" : "it-IT";
  return (
    <div className="border-t border-gray-800 pt-4" data-testid="infra-peaks">
      <p className="flex items-center gap-2 text-sm text-white font-medium"><Activity size={15} /> {t.title}</p>
      <p className="text-[11px] text-gray-500 mt-1 mb-2">{t.note}</p>
      {peaks.length === 0 ? <p className="text-xs text-gray-500" data-testid="infra-peaks-empty">{t.empty}</p> : (
        <table className="w-full text-xs">
          <thead><tr className="text-gray-500 text-left"><th className="py-2 pr-4 font-normal">{t.when}</th><th className="py-2 pr-4 text-right font-normal">{t.pct}</th><th className="py-2 text-right font-normal">{t.used}</th></tr></thead>
          <tbody>
            {peaks.map((p, i) => (
              <tr key={p.at} className="border-t border-gray-800 text-gray-300" data-testid={`infra-peak-row-${i}`}>
                <td className="py-2 pr-4">{new Date(p.at).toLocaleString(loc)}</td>
                <td className={`py-2 pr-4 text-right font-semibold ${p.max_pct >= red ? "text-red-400" : "text-white"}`}>{p.max_pct}%</td>
                <td className="py-2 text-right">{Math.round(p.max_used / 1048576)} MB</td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};
